// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

const StyledSlot = styled.div`
	position: relative;
	width: 2rem;
	height: 2.5rem;
	font-size: 2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-bottom: 1px solid
		${({ theme: { colors, isDarkMode } }) =>
			isDarkMode ? "var(--dz-sys-text-color)" : colors.whiteTrue};

	${({ isFilled }) =>
		isFilled &&
		css`
			border-bottom: 1px solid transparent;
		`}
`;

const StyledFakeCaretWrapper = styled.div`
	pointer-events: none;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: caret-blink 1.2s ease-out infinite;

	@keyframes caret-blink {
		0%,
		70%,
		100% {
			opacity: 1;
		}
		20%,
		50% {
			opacity: 0;
		}
	}
`;

const StyledCharacterWrapper = styled.div`
	font-weight: bold;
	font-size: 18px;
`;

const StyledFakeCaret = styled.div`
	width: 1px;
	height: 1rem;
	background-color: ${({ theme: { colors, isDarkMode } }) =>
		isDarkMode ? "var(--dz-sys-text-color)" : colors.whiteTrue};
`;

// #####################################################
export const OtpSlot = ({ char, hasFakeCaret }) => {
	// #####################################################

	return (
		<StyledSlot isFilled={char !== null}>
			{char !== null && (
				<StyledCharacterWrapper>{char}</StyledCharacterWrapper>
			)}
			{hasFakeCaret && (
				<StyledFakeCaretWrapper>
					<StyledFakeCaret />
				</StyledFakeCaretWrapper>
			)}
		</StyledSlot>
	);
};

// #####################################################
